module.exports = __webpack_public_path__ + "img/delar-agree.05a966ef.png";